module.exports = __webpack_public_path__ + "static/media/gear.0554201f.svg";